import { FileText, FileSpreadsheet, Presentation, File } from 'lucide-react';
import type { DamFile } from 'mocks/dam';

const EXT_COLORS: Record<DamFile['ext'], string> = {
  pdf: '#dc2626',
  docx: '#1474FF',
  xlsx: '#059669',
  pptx: '#d97706',
  txt: '#506070',
  md: '#506070',
};

export function FileExtIcon({ ext, size = 15 }: { ext: DamFile['ext']; size?: number }) {
  const color = EXT_COLORS[ext];
  if (ext === 'xlsx') return <FileSpreadsheet size={size} color={color} />;
  if (ext === 'pptx') return <Presentation size={size} color={color} />;
  if (ext === 'pdf' || ext === 'docx') return <FileText size={size} color={color} />;
  return <File size={size} color={color} />;
}

export function formatSizeKb(sizeKb: number): string {
  return sizeKb >= 1024 ? `${(sizeKb / 1024).toFixed(1)} МБ` : `${sizeKb} КБ`;
}

export function formatDamDate(iso: string): string {
  const [y, m, d] = iso.split('-');
  const months = [
    'янв',
    'фев',
    'мар',
    'апр',
    'май',
    'июн',
    'июл',
    'авг',
    'сен',
    'окт',
    'ноя',
    'дек',
  ];
  return `${Number(d)} ${months[Number(m) - 1]} ${y}`;
}
